module.exports = __webpack_public_path__ + "img/home_icon_zhuangshi_sel.2203391b.png";